__turbopack_context__.v({
  "active": "interactive-object-link-module-scss-module__hwjJpa__active",
  "link": "interactive-object-link-module-scss-module__hwjJpa__link",
});
